import { Component, Injectable, Input } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { AdministrationService } from '../../../../../app/services/administration.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackUserManagerModel } from '../../../../../app/models/data.manager.model';
import { DataPackGroup } from '../../../../models/dataPackGroup.model';

/**
 * @author Wesley Mascarenhas
 * @version $Id: content.component.ts 79366 2018-02-17 00:40:37Z thiago.h.neri $
 */
 @Component({
  selector:     'removeAdministrator',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class RemoveAdministratorComponent {

  @Input() model: DataPackUserManagerModel;

  private removing: boolean;
  private messageGroups: string = null;
  private associatedGroups: Array<DataPackGroup> = [];

  constructor(private activeModal: NgbActiveModal, private adminService: AdministrationService, private alertService: AlertService) {

  }

  ngOnInit() {
  	this.prepareMessage();
  }

  private prepareMessage() {
    this.messageGroups = '';
  	if (this.model.dataPackGroupList.length > 0) {
  	  let aux = 1;
  	  for (let group of this.model.dataPackGroupList) {
  	  	this.messageGroups = this.messageGroups.concat(group.name);
  	  	if (aux < this.model.dataPackGroupList.length) {
  	  	  this.messageGroups = this.messageGroups.concat(', ');
  	  	}
  	  	aux++;
  	  }
  	}
  }

  private close() {
    this.activeModal.dismiss();
  }

  private remove() {
    this.removing = true;
    this.model['action'] = 'remove';
    this.adminService.remove(this.model).subscribe(
      data => {
        this.removing = false;
        this.activeModal.close();
        this.alertService.success(data['result']);
      },
      err => {
        this.removing = false;
        this.activeModal.close();
        this.alertService.error(err.result, err);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/administration/remove/content.component.ts